import { Component, OnInit } from '@angular/core';

/**
 * 一般機能モジュールメインコンポーネント
 * @export
 * @class CisBaseComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-cis-base',
  templateUrl: './cis-base.component.html',
  styleUrls: ['./cis-base.component.scss']
})
export class CisBaseComponent implements OnInit {
  /**
   * コンストラクタ
   * @memberof CisBaseComponent
   */
  constructor() {
  }

  /**
   * 初期化処理
   * @memberof CisBaseComponent
   */
  ngOnInit(): void {
  }

}
